module.exports = __webpack_public_path__ + "img/bili.3c76b638.svg";